import { render, staticRenderFns } from "./SpotlightAdForm.vue?vue&type=template&id=0d3415d9&"
import script from "./SpotlightAdForm.vue?vue&type=script&lang=js&"
export * from "./SpotlightAdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports